import { Pipe, PipeTransform } from '@angular/core';
import { TrainingProposalsPluginService } from './trainingproposals-plugin.service';

@Pipe({
    name: 'momentpipe',
    standalone: false
})
export class MomentPipe implements PipeTransform {
  public moments: any;

  constructor(private service: TrainingProposalsPluginService) {
    this.service.getMoments().subscribe((data) => {
      this.moments = data;
    });
  }

  transform(id: string): any {
    return this.service.getValue(id, this.moments);
  }
}
